import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { globalVariables } from "helper/globalVariables";
import { BACKGROUND_SVG } from "./template/Background";
import moment from "moment";
import { LOGO_SVG } from "./template/Logo";
import { SIGN_SVG } from "./template/signature";
import { TEXT_SVG } from "./template/text";
import { signatureNew } from "helper/images";

export const Certificate = forwardRef((props, ref) => {
  const { setLoading } = props || {};
  const [certificateData, setCertificateData] = useState({
    name: "",
    designation: "",
    date: "",
  });
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    getCertificateData: () => certificateData,
    onGenerateCertificate: (name, designation, date) => {
      setCertificateData({ name, designation, date });
      setIsVisible(true);
    },
    onGeneratePdf: () => {
      if (certificateData.name && certificateData.designation && certificateData.date) {
        setTimeout(() => {
          handleGeneratePdf();
        }, 500);
      }
    },
  }));

  const handleGeneratePdf = async () => {
    setLoading(true);
    const element = document.getElementById("certificate-container");
    if (!element) {
      console.error("Certificate container not found");
      setLoading(false);
      return;
    }

    setIsVisible(true);

    const clonedElement = element.cloneNode(true);
    clonedElement.style.position = "absolute";
    clonedElement.style.left = "-9999px";
    document.body.appendChild(clonedElement);

    let canvas = await html2canvas(clonedElement, { 
      scale: 2, 
      useCORS: true, 
      foreignObjectRendering: false, 
      allowTaint: true, 
      taintTest: false 
    });
    document.body.removeChild(clonedElement);

    let imgData = canvas.toDataURL("image/png");
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4", compress: true });
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();
    doc.addImage(imgData, "PNG", 0, 0, width, height);
    doc.save("certificate.pdf");

    setLoading(false);
    setCertificateData({ name: "", designation: "", date: "" });
    setIsVisible(false);
  };

  useEffect(() => {
    if (certificateData.name && certificateData.designation && certificateData.date) {
      setTimeout(() => {
        handleGeneratePdf();
      }, 500);
    }
  }, [certificateData]);

  return (
    <div
      id="certificate-container"
      className={`w-[1089px] h-[768px] relative text-black bg-cover bg-center flex items-center justify-center ${isVisible ? "block" : "hidden"}`}
      style={{ backgroundImage: `url('data:image/svg+xml,${encodeURIComponent(BACKGROUND_SVG)}')` }}
    >
      <div className="p-5 text-center flex flex-col justify-center items-center">
          <p className="font-glidaDisplay text-[56px] font-light tracking-normal mt-[-120px]">
            {globalVariables.certificateTitle}
          </p>
          <p className="font-glidaDisplay text-[28px] text-gray-700 mt-[32px] mb-[24px]">
            {globalVariables.awardedTo}
          </p>
          <p className="font-italianno font-normal text-[160px] mt-[-160px] text-purple-700 mb-[64px]">
            {certificateData.name}
          </p>
          <div>
            <img src={`data:image/svg+xml;base64,${btoa(TEXT_SVG)}`} alt="text" className="w-[400px]"  />
          </div>
          <h2 className="font-playfairDisplay leading-[90px] text-[60px] font-bold text-blue mt-[-32px]">
            {certificateData.designation}
          </h2>
          <p className="font-glidaDisplay text-[28px] font-normal text-black">
            {globalVariables.on} {moment.utc(certificateData?.date).format("MMM DD, YYYY")}
          </p>
      </div>
      <div className="absolute bottom-[130px] right-[200px] text-center">
        <img src={signatureNew} alt="Signature" className="w-[270px]" />
        <div className="bg-blue w-full h-[1px] top-[40px]"></div>
        <p className="left-[50px] text-[21px] absolute top-[65px]">Rosana C Dropkin</p>
      </div>
      <img
        src={`data:image/svg+xml;base64,${btoa(LOGO_SVG)}`}
        alt="K9 Scent Games Logo"
        className="absolute bottom-[110px] left-[200px] w-[150px]"
      />
    </div>
  );
});
